import { useQuery, keepPreviousData } from '@tanstack/react-query';
import { ApiResponse } from 'further-types/api';
import { api } from 'lib/httpClient';
import { Api } from 'further-types/adviser';
import { QUERY_STALE_TIME_MS } from 'further-ui/config';

// TODO: refactor to use correct type - AdviserApi.AdviserListResponse
export function useAdvisers({ params }) {
  return useQuery({
    queryKey: ['advisers', { params }],
    queryFn: async () => {
      const {
        data: { data },
      } = await api.get<ApiResponse<any>>('adviser/list', { params });

      return data;
    },
    placeholderData: keepPreviousData,
    staleTime: QUERY_STALE_TIME_MS,
  });
}

export function useAdvisersLeanResponse(
  params: Api.ListAdviserLeanQuery,
  refetchOnWindowFocus?: boolean,
) {
  return useQuery({
    queryKey: ['advisers-lean-response', { params }],
    queryFn: async () => {
      const { data } = await api.get<ApiResponse<Api.ListAdviserLeanResponse>>(
        'adviser/list/lean-response',
        { params },
      );
      return data.data;
    },
    placeholderData: keepPreviousData,
    refetchOnWindowFocus: refetchOnWindowFocus ? 'always' : false,
    staleTime: refetchOnWindowFocus ? 0 : QUERY_STALE_TIME_MS,
  });
}
